
import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import ImageSlider from '../imageSlider'
import { configs } from '../../helpers/constants'
import Search from '../search'
import $ from 'jquery'
import { Route, NavLink, HashRouter, Router } from "react-router-dom";
import StarRatings from 'react-star-ratings'
import { ScaleLoader } from 'react-spinners'
import RatingReadOnly from 'react-rating'
import { get, post } from '../../utils/networking'
import './style.css'
import { concatStatic } from 'rxjs/operator/concat';
import Slider from './slider'
import { POINT_CONVERSION_COMPRESSED } from 'constants';
export class HomePage extends Component {

    constructor(props) {
        super(props)
        this.state = {
            keyword: "",
            location: "",
            homeBlogContentBlueSize: 200,
            isstart: false,
            topTrading: [],
            banners: [],
            wellnessLifeStyle: [],
            wellnessTravel: [],
            topRates: [],
            isLoaded: false
        }
    }

    handleResize() {
        let size = $(".home-blog-content-blue").width();
        this.setState({
            homeBlogContentBlueSize: (size) ? size : 200
        })
    }

    componentDidMount() {
        get('web/homePage', "", result => {
            this.setState({
                banners: result.banners,
                wellnessLifeStyle: result.wellnessLifeStyle,
                wellnessTravel: result.wellnessTravel,
                topRates: result.topRates,
                isLoaded: true
            })
        })

        window.addEventListener("resize", this.handleResize());
        post("spa/topTrading", { "skip": 0, "take": 4 }, "", result => {
            if (result) {
                this.setState({
                    topTrading: result.items
                })
            }
        })

    }

    render() {


        var settings = {
            dots: true,
            infinite: true,
            speed: 700,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: true
        }
        let {
            homeBlogContentBlueSize,
            // topTrading,
            banners,
            wellnessLifeStyle,
            wellnessTravel,
            topRates,
            isLoaded
        } = this.state;




        let photos = []

        banners.map((banner, i) =>
            photos.push(
                <NavLink to={banner.link} key={i} style={{ display: "block", textAlign: "center" }} >
                    <img src={configs.api_domain + banner.photo} alt="" style={{ display: "inline-block", height: "400px", width: "100%" }} />
                </NavLink>)
        )

        let topTrading = []
        wellnessLifeStyle.map((blog, i) => {
            if (blog.type == 1) topTrading.push(blog)
        })


        return (
            < div >
                <main>
                    {
                        (isLoaded) ? <div className="border_line_bottom">
                            <div className="container">
                                <div className="content clearfix page_top">
                                    <div className="slider" >
                                        <div className="search">
                                            <div className="clearfix row_col">
                                                {/* <div className="col_3 col_sm_12 button_gift_cards">
                                                    <div className="clearfix">
                                                        <div className="col_9 col_sm_12">
                                                            <NavLink to="#" className="button green">SHOP GIFT CARDS</NavLink>
                                                        </div>
                                                        <div className="col_3 col_sm_12 or"><p>_ or _</p></div>
                                                    </div>
                                                </div> */}
                                                <div className="col_2 col_sm_12 find">
                                                    <div className="clearfix">
                                                        <div className="col_7 col_sm_12"><p><span>FIND</span><br />SERVICES</p></div>
                                                        <div className="col_5">&raquo;</div>
                                                    </div>
                                                </div>
                                                <div className="col_7 search-ct">
                                                    <Search history={this.props.history} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="top_slider">
                                            <Slider />
                                        </div>

                                    </div>


                                    {
                                        topTrading.length > 0 ? <div className="wellness wellness_lifestyle">
                                            <h3 className="home-strike-title"><span className="i-block">Trending Now</span></h3>
                                            <article>
                                                <div className="clearfix list_article">
                                                    {topTrading.map((blog, i) =>
                                                        <div className="col_3 col_sm_12" key={i} >
                                                            <div className="img" style={{ background: "url(" + configs.api_domain + blog.photo + ")" }}>
                                                                <NavLink to={"/blog/" + blog.slug}>
                                                                    <span className="home-blog-cat">{blog.category.name}</span>
                                                                </NavLink>
                                                            </div>
                                                            <div className="content-blog">
                                                                <p className="home-blog-date">{moment(blog.publicDate).format("MMMM DD , YYYY")} at {moment(blog.publicDate).format("hh:mm a")}</p>
                                                                <p className="home-blog-author">Nail spa of america</p>
                                                                <p className="home-blog-content-blue">{String(blog.title).substring(0, (homeBlogContentBlueSize / 9) * 2) + "  ..."}</p>
                                                                <p className="home-blog-content-black">{blog.synopsis}</p>
                                                                <p className="home-blog-cta"><NavLink to={"/blog/" + blog.slug}>Read more...</NavLink></p>
                                                                <p className="home-blog-linkout"><NavLink to={"/blog/category/" + blog.category.slug}>{blog.category.name}</NavLink></p>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <NavLink to="/blogs"><span className="read-more-spa">See more Popular Services</span></NavLink>
                                            </article>
                                        </div> : ""
                                    }

                                    <div className="top-spa">
                                        <h3 className="home-strike-title"><span className="i-block" >Top rating</span></h3>
                                        <div className="top-spa-detail">
                                            {
                                                (topRates) ? topRates.map((spa, i) =>
                                                    <div className={"top-spa-item"} key={i}>
                                                        <div className="item-detail">
                                                            <NavLink to={"spa/" + ((spa.slug) ? spa.slug : "")} ><div className="detail-left-image" style={{ background: "url(" + ((spa.photo) ? ("http://pos.nailspaofamerica.com/ClientWeb/FileUpload/" + spa.photo) : "http://binhphuoc.gov.vn/themes/default/images/businesslistings/noimages.png") + ")" }} ></div></NavLink>
                                                            <div className="detail-right">
                                                                <NavLink to={"spa/" + spa.slug} ><span className="spa-name">{spa.name}</span></NavLink>
                                                                <div className="rating-review">
                                                                    <StarRatings
                                                                        rating={spa.rate}
                                                                        starRatedColor="#935ed6"
                                                                        numberOfStars={5}
                                                                        starSpacing="9px"
                                                                        starEmptyColor="#e3ceff"
                                                                    />
                                                                    <span className="review-count">{spa.reviews} Reviews</span>
                                                                </div>
                                                                <span className="spa-address">{spa.address1}</span>
                                                                {
                                                                    (spa.latestReview) ? <div className="lastest-review">
                                                                        <div className="left">
                                                                            <span className="name">Review by:<br />{(spa.latestReview) ? spa.latestReview.reviewerName : ""}</span>
                                                                        </div>
                                                                        <div className="right">
                                                                            <span className="title">{(spa.latestReview) ? spa.latestReview.title : ""}</span>
                                                                            <RatingReadOnly
                                                                                color="red"
                                                                                initialRating={(spa.latestReview) ? spa.latestReview.overallRating : ""}
                                                                                emptySymbol={<img src={require('../../assets/images/star_empty.png')} className="icon" style={{ width: "15px", marginRight: "2px" }} />}
                                                                                fullSymbol={<img src={require('../../assets/images/star.png')} className="icon" style={{ width: "15px", marginRight: "2px" }} />}
                                                                                readonly
                                                                            />
                                                                            <span className="decription">{(spa.latestReview) ? spa.latestReview.description.substring(0, 60) : ""}</span>
                                                                            <span className="see-more"><NavLink to={"spa/" + ((spa.slug) ? spa.slug : "")}>Read more...</NavLink></span>
                                                                        </div>
                                                                    </div> : <div className="lastest-review">
                                                                            <div className="left">
                                                                                <span className="name">No review</span>
                                                                            </div>
                                                                            <div className="right">
                                                                            </div>
                                                                        </div>
                                                                }

                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : ""
                                            }
                                        </div>
                                        <NavLink to="/spa?keyword=&location=&type=1"><span className="read-more-spa">See more Top Nails Salon</span></NavLink>
                                    </div>

                                    <div className="wellness wellness_lifestyle">
                                        <h3 className="home-strike-title"><span className="i-block">Wellness Lifestyle</span></h3>
                                        <article>
                                            <div className="clearfix list_article">
                                                {wellnessLifeStyle.map((blog, i) =>
                                                    <div className="col_3 col_sm_12" key={i} >
                                                        <div className="img" style={{ background: "url(" + configs.api_domain + blog.photo + ")" }}>
                                                            <NavLink to={"/blog/" + blog.slug}>
                                                                <span className="home-blog-cat">{blog.category.name}</span>
                                                            </NavLink>
                                                        </div>
                                                        <div className="content-blog">
                                                            <p className="home-blog-date">{moment(blog.publicDate).format("MMMM DD , YYYY")} at {moment(blog.publicDate).format("hh:mm a")}</p>
                                                            <p className="home-blog-author">Nail spa of america</p>
                                                            <p className="home-blog-content-black">{blog.synopsis}</p>
                                                            <p className="home-blog-content-blue">{String(blog.title).substring(0, (homeBlogContentBlueSize / 9) * 2) + "  ..."}</p>
                                                            <p className="home-blog-cta"><NavLink to={"/blog/" + blog.slug}>Read more...</NavLink></p>
                                                            <p className="home-blog-linkout"><NavLink to={"/blog/category/" + blog.category.slug}>{blog.category.name}</NavLink></p>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <NavLink to="/blogs"><span className="read-more-spa">See more Popular Services</span></NavLink>
                                        </article>
                                    </div>
                                    {
                                        wellnessTravel.length > 0 &&
                                        <div className="wellness wellness_travel">
                                            <h3 className="home-strike-title"><span className="i-block">Wellness Travel</span></h3>
                                            <article>
                                                <div className="clearfix list_article">
                                                    {wellnessTravel.map((blog, i) =>
                                                        <div className="col_4 col_sm_12" key={i}>
                                                            <div className="border">
                                                                <div className="img">
                                                                    <NavLink to={"/blog/" + blog.slug}>
                                                                        <img src={configs.api_domain + blog.photo} alt="" />
                                                                    </NavLink>
                                                                </div>
                                                                <div className="content-blog">
                                                                    <p className="home-blog-date">{moment(blog.publicDate).format("MMMM DD , YYYY")} at {moment(blog.publicDate).format("hh:mm a")}</p>
                                                                    <h4 className="home-blog-author">Nail spa of america</h4>
                                                                    <p className="home-blog-content-blue">{blog.title}</p>
                                                                    <p className="home-blog-content-black">{blog.synopsis}</p>
                                                                    <p className="home-blog-cta"><NavLink to={"/blog/" + blog.slug}>Read more</NavLink></p>
                                                                    <p className="home-blog-linkout"><NavLink to={"/blog/category/" + blog.category.slug}>{blog.category.name}</NavLink></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="home-blog-load">
                                                    <NavLink to="/blogs">See more Popular Services</NavLink>
                                                </div>
                                            </article>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div> : <div style={{ width: "100%", height: "100vh", textAlign: "center", paddingTop: "40vh" }}>
                                <ScaleLoader
                                    color={'#935ed6'}
                                    loading={true}
                                    width={10}
                                    height={60}
                                    margin="1px"
                                    radius={0}
                                />
                            </div>
                    }
                </main>
            </div >
        )
    }
}

export default HomePage


// WEBPACK FOOTER //
// ./src/components/home/index.js